// ABOUTME: API slice for external channels management using RTK Query
// ABOUTME: Handles CRUD operations, test connection, and caching for external channel integrations (e.g., Prediko)

import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const EXTERNALCHANNEL_BASE = "/externalchannel";
const buildUrl = (endpoint) => EXTERNALCHANNEL_BASE + endpoint;
const ApiName = "ExternalChannel";

const externalChannelSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getExternalChannels: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: `${ApiName}-List` }, { type: ApiName }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getExternalChannel', ApiName),
        }),
        getExternalChannelSingle: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
                meta: { customContentType: true },
            }),
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: ApiName, id: id }],
        }),
        getExternalChannelsSelect: builder.query({
            query: () => ({
                url: buildUrl(``),
                method: 'GET',
            }),
            providesTags: () => [{ type: `${ApiName}-Select` }],
        }),
        createExternalChannel: builder.mutation({
            query: info => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: info,
            }),
            invalidatesTags: (result, error, arg) => [{ type: ApiName }, { type: ApiName, id: 'ZONOS_AVAILABILITY' }, { type: `${ApiName}-List` }, { type: `${ApiName}-Select` }],
        }),
        editExternalChannel: builder.mutation({
            query: info => ({
                url: buildUrl(`/${info.id}`),
                method: 'PUT',
                body: info,
            }),
            invalidatesTags: (result, error, arg) => [{ type: ApiName, id: arg.id }, { type: ApiName, id: 'ZONOS_AVAILABILITY' }, { type: `${ApiName}-List` }],
        }),
        deleteExternalChannel: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, id) => [{ type: ApiName, id: id }, { type: ApiName, id: 'ZONOS_AVAILABILITY' }, { type: `${ApiName}-List` }, { type: `${ApiName}-Select` }],
        }),
        testExternalChannelConnection: builder.mutation({
            query: info => ({
                url: buildUrl(`/${info.id}/testconnection`),
                method: 'POST',
                body: info.credentials,
            }),
        }),
        connectOutlookChannel: builder.mutation({
            query: info => ({
                url: buildUrl(`/${info.id}/outlook/exchange`),
                method: 'POST',
                body: { code: info.code },
            }),
            invalidatesTags: (result, error, arg) => [{ type: ApiName, id: arg.id }, { type: `${ApiName}-List` }],
        }),
        getZonosAvailability: builder.query({
            query: (relationId) => ({
                url: buildUrl(`/zonos/available${relationId ? `?relationId=${relationId}` : ''}`),
                method: 'GET',
            }),
            providesTags: () => [{ type: ApiName, id: 'ZONOS_AVAILABILITY' }],
        }),
        syncZonosProduct: builder.mutation({
            query: info => ({
                url: buildUrl(`/zonos/syncproduct`),
                method: 'POST',
                body: { productId: info.productId },
            }),
        }),
    })
});

export const {
    useGetExternalChannelsQuery,
    useGetExternalChannelSingleQuery,
    useGetExternalChannelsSelectQuery,
    useCreateExternalChannelMutation,
    useEditExternalChannelMutation,
    useDeleteExternalChannelMutation,
    useTestExternalChannelConnectionMutation,
    useConnectOutlookChannelMutation,
    useGetZonosAvailabilityQuery,
    useSyncZonosProductMutation
} = externalChannelSlice;
